// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uWzf0{overflow:hidden}.xvku4{overflow-x:hidden;overflow-y:hidden;position:relative}.hD2x0{position:relative;z-index:10}.K8gMW{padding:24px 16px 16px}.VGPmv{position:absolute;left:0;right:0;display:flex;flex-direction:column;z-index:2}.h6wTR{top:0;bottom:0}.z08Uv{top:128px;bottom:80px}.pBcSr{position:absolute;bottom:0;left:0;right:0;z-index:10}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `uWzf0`,
	"contentBox": `xvku4`,
	"headerWrapper": `hD2x0`,
	"titleWrapper": `K8gMW`,
	"contentArea": `VGPmv`,
	"contentAreaCover": `h6wTR`,
	"contentAreaOnboarding": `z08Uv`,
	"footerWrapper": `pBcSr`
};
export default ___CSS_LOADER_EXPORT___;
